import { ScopeSequenceStandard } from "src/app/services/graphql/scope-sequence-standards-response";
import { Injectable } from "@angular/core";
import { DomainStandard } from "src/app/home/scope-sequence/models/domain-standards.model";
import { DomainStandardService } from "./domain-standard.service";

@Injectable({ providedIn: 'root' })
export class ScopeSequenceService { 
  constructor(private domainStandardService: DomainStandardService) { }

  public generateDomainStandards(standards: ScopeSequenceStandard[]): DomainStandard[] {
      const domainStandards = this.domainStandardService.groupIntoDomainStandards(standards);
      
      domainStandards.forEach(domainStandard => {
        this.domainStandardService.sortStandardSetsCollection(domainStandard);
        this.domainStandardService.setSettings(domainStandard);

        domainStandard.standardSets.forEach(standard => {
          this.formatSkillNames(standard);
          this.sortSkillNames(standard);
        });
      });

      return domainStandards;
  }

  private formatSkillNames(standard: ScopeSequenceStandard) {
      const sanitizedSkillNames = standard.skillNames.map((name: string) => name.replace(/"/g, ''));
      standard.skillNames = sanitizedSkillNames;
  };
  
  private sortSkillNames(standard: ScopeSequenceStandard) {
    standard?.skillNames.sort((a: string, b: string) => a.localeCompare(b));
  };
}
